import { env } from '@/config/env';

const RC_APP_BASE = 'https://app.revenuecat.com/projects';

/**
 * Deep links into the RevenueCat dashboard. The project id is baked in at
 * build time and differs per environment, so it can be missing (empty) in a
 * build that was not given one — return null then and let callers drop the
 * link instead of pointing at a non-existent project.
 */
export const rcCustomerUrl = (appUserId: string | number): string | null =>
  env.RC_PROJECT_ID
    ? `${RC_APP_BASE}/${env.RC_PROJECT_ID}/customers/${encodeURIComponent(appUserId)}?tab=overview`
    : null;

export const rcProductUrl = (productId: string): string | null =>
  env.RC_PROJECT_ID
    ? `${RC_APP_BASE}/${env.RC_PROJECT_ID}/product-catalog/products/${encodeURIComponent(productId)}`
    : null;
